import { useEffect, useState } from 'react';
import { TbMessageCircle2 } from 'react-icons/tb';
import { format } from 'date-fns';
import DATE_FORMATS from '@constants/dateFormat';
import { ActivityTrackerView } from '@th-types/jobs.type';
import { ActivityDetail } from '@th-types/daily-activity.type';
import { isMobile } from 'react-device-detect';
import { Stack } from 'react-bootstrap';
import './styles.scss';
import { useChatContext } from '@company/state/chatContext';
import { JobAssignment } from '@th-types/job.detail.type';
import { useJobAssignmentStatus } from '@hooks/useJobAssignmentStatus';
import ButtonMarkAllAsPaid from './ButtonMarkAllAsPaid';
import ButtonMarkAllOnboardingAsCompleted from './ButtonMarkAllOnboardingAsCompleted';

interface Props {
  viewType: string;
  groupedBy: string;
  filteredActivities: ActivityDetail[];
  openWorkerSideModal: (jobAssignment: JobAssignment) => void;
  handleConfirmMarkPaid: (
    groupedBy: string,
    id: number,
    filteredActivities: ActivityDetail[],
    all?: boolean
  ) => void;
}
export default function ActivityTrackerTableHeader({
  handleConfirmMarkPaid,
  openWorkerSideModal,
  viewType,
  groupedBy,
  filteredActivities,
}: Props) {
  const { openChat } = useChatContext();
  const [jobAssignment, setJobAssignment] = useState<JobAssignment>();
  const jobAssignmentStatus = useJobAssignmentStatus()(undefined);
  const { shouldShowWorkerInfoInChat } = jobAssignmentStatus;

  useEffect(() => {
    if (filteredActivities.length > 0) {
      setJobAssignment(filteredActivities[0].shiftPosition.jobAssignment);
    }
  }, [filteredActivities]);

  if (!jobAssignment) {
    return null;
  }

  return (
    <div className="d-flex justify-content-between align-items-center my-3">
      {viewType === ActivityTrackerView.DATE ? (
        <div>
          <span className="fw-bold at-table-header">
            {format(new Date(groupedBy), DATE_FORMATS.LIST_BY_DATE_FORMAT)}
          </span>
        </div>
      ) : (
        <div>
          <span
            className="fw-bold pe-3 text-capitalize at-table-header cursor-point at-name-link"
            onClick={() => openWorkerSideModal(jobAssignment)}
          >
            {groupedBy}
          </span>

          <TbMessageCircle2
            color="var(--black)"
            className="cursor-point pb-1"
            onClick={() =>
              openChat(
                jobAssignment.worker,
                jobAssignment.id,
                shouldShowWorkerInfoInChat({
                  status: jobAssignment.status,
                })
              )
            }
            size={24}
          />
        </div>
      )}
      <Stack direction="horizontal" gap={3}>
        {!isMobile && (
          <ButtonMarkAllOnboardingAsCompleted
            jobAssignments={filteredActivities.map(
              (item) => item.shiftPosition.jobAssignment!
            )}
          />
        )}
        <ButtonMarkAllAsPaid
          filteredActivities={filteredActivities}
          groupedBy={groupedBy}
          handleConfirmMarkPaid={handleConfirmMarkPaid}
        />
      </Stack>
    </div>
  );
}
